import { defineMessages } from 'react-intl';

export default defineMessages({
  cartUpdateMessage: {
    id: 'cartUpdateMessage',
    description: 'cart content update',
    defaultMessage:
      'Your cart has been modified by another user. Please proceed to see the most recent updates.',
  },
  confirmationMessage: {
    id: 'confirmationMessage',
    description: 'confirm cart update',
    defaultMessage: 'Proceed',
  },
});
